import Vue from 'vue'
import Vuex, { MutationTree } from 'vuex'

Vue.use(Vuex)

export interface State {
  openIndustryFilter: boolean
  openBrandFilter: boolean
  openCategoryFilter: boolean
  minThreshold: number
  maxThreshold?: number
}

export const state: State = {
  openIndustryFilter: false,
  openCategoryFilter: false,
  minThreshold: 0,
  maxThreshold: undefined,
  openBrandFilter: false
}

export const MutationTypes = {
  SET_OPEN_INDUSTRY_FILTER: 'setOpenIndustryFilter',
  SET_OPEN_CATEGORY_FILTER: 'setOpenCategoryFilter',
  SET_PRICE_RANGE: 'setPriceRange',
  SET_OPEN_BRAND_FILTER: 'setOpenBrandFilter'
} as const

export const mutations: MutationTree<State> = {
  [MutationTypes.SET_OPEN_INDUSTRY_FILTER]: (
    state: State,
    payload: boolean
  ): void => {
    state.openIndustryFilter = payload
  },
  [MutationTypes.SET_OPEN_BRAND_FILTER]: (
    state: State,
    payload: boolean
  ): void => {
    state.openBrandFilter = payload
  },
  [MutationTypes.SET_OPEN_CATEGORY_FILTER]: (
    state: State,
    payload: boolean
  ): void => {
    state.openCategoryFilter = payload
  },
  [MutationTypes.SET_PRICE_RANGE]: (
    state: State,
    { minThreshold, maxThreshold } : { minThreshold: number, maxThreshold: number }
  ): void => {
    state.minThreshold = minThreshold
    state.maxThreshold = maxThreshold
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations
})
